<p-toggleButton [ngModel]="isDark" onIcon="pi pi-sun " offIcon="pi pi-moon"
  styleClass="w-8 h-8 rounded-full   left-0 md:left-0 " (onChange)="switchTheme($event)" />